import { Container } from '@mui/material';
import BasePage from '../BasePage';
import AdminLayout from '../../components/AdminLayout';
import AdminPageHeader from '../../components/admin/shared/AdminPageHeader';
import AdminLoadingState from '../../components/admin/shared/AdminLoadingState';
import SystemTabs from '../../components/admin/system/SystemTabs';
import { useAdminSystem } from '../../hooks/admin/useAdminSystem';

/**
 * AdminSystem - System health monitoring page
 *
 * Section 6: System Health
 * - Service status overview (Workers API, Durable Objects, D1, R2, KV)
 * - Error tracking dashboard with resolution workflow
 * - Performance metrics (response times, throughput, database)
 * - Cache management (R2, KV hit rates and operations)
 * - Database health (connections, query performance, slow queries)
 *
 * Features:
 * - 5 tabbed sections with comprehensive monitoring
 * - Real-time status indicators
 * - 24-hour trend charts
 * - Error log with detail modal
 * - Performance percentiles (p50, p95, p99)
 * - Cache hit rate tracking
 * - Slow query analysis with optimization suggestions
 */
export default function AdminSystem() {
  const { systemHealthData, isLoading, refresh, clearCache, resolveError } = useAdminSystem();

  if (isLoading && !systemHealthData) {
    return (
      <BasePage title="System Health | CribCritic Admin" description="System monitoring">
        <AdminLayout>
          <Container maxWidth="xl">
            <AdminLoadingState message="Loading system health data..." />
          </Container>
        </AdminLayout>
      </BasePage>
    );
  }

  return (
    <BasePage title="System Health | CribCritic Admin" description="Monitor platform infrastructure and performance">
      <AdminLayout>
        <Container maxWidth="xl">
          <AdminPageHeader
            title="System Health"
            subtitle="Monitor Cloudflare Workers, D1, R2, KV, and platform performance"
          />

          <SystemTabs
            data={systemHealthData}
            loading={isLoading}
            onRefresh={refresh}
            onResolveError={resolveError}
            onClearCache={clearCache}
          />
        </Container>
      </AdminLayout>
    </BasePage>
  );
}
